export default __webpack_public_path__ + "static/air_compressor_b.b9c5e92060a2c597560d6d00f12f79b2.png";